import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/services/guards/auth-guard.guard';
import { DashboardContainerComponent } from './components/dashboard-container/dashboard-container.component';
import { DashboardComponent } from './dashboard.component';
import { ViewContainerComponent } from './components/view-container/view-container.component';
import { RoleAccessGuard } from 'src/app/services/guards/role.guard';
const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: DashboardContainerComponent,
      },
      {
        path: 'view',
        component: ViewContainerComponent,
      },
      {
        path: 'assets',
        loadChildren: () =>
          import('../assets/assets.module').then((m) => m.AssetsModule),
        canActivate: [RoleAccessGuard],
      },
      {
        path: 'media',
        loadChildren: () =>
          import('../media-wall/media-wall.module').then(
            (m) => m.MediaWallModule
          ),
        canActivate: [RoleAccessGuard],
      },
      {
        path: 'calendar',
        loadChildren: () =>
          import('../calendar/calendar.module').then(
            (m) => m.CalendarViewModule
          ),
        canActivate: [RoleAccessGuard],
      },
      {
        path: 'manageuser',
        loadChildren: () =>
          import('../manage-user/manage-user.module').then(
            (m) => m.ManageUserModule
          ),
        canActivate: [RoleAccessGuard],
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('../settings/settings.module').then((m) => m.SettingsModule),
        canActivate: [RoleAccessGuard],
      },
      {
        path: 'guard',
        loadChildren: () =>
          import('../security-guard/security-guard.module').then(
            (m) => m.SecurityGuardModule
          ),
        canActivate: [RoleAccessGuard],
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('../reports/reports.module').then((m) => m.ReportsModule),
        canActivate: [RoleAccessGuard],
      },
      {
        path: 'analytics',
        loadChildren: () =>
          import('../analytics/analytics.module').then(
            (m) => m.AnalyticsModule
          ),
        canActivate: [RoleAccessGuard],
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('../user-profile/user-profile.module').then(
            (m) => m.UserProfileModule
          ),
        data: { breadcrumb: { label: 'User Profile' } },
      },
      {
        path: 'emergency',
        loadChildren: () =>
          import('../aumye-maps/aumye-maps.module').then(
            (m) => m.AumyeMapsModule
          ),
        canActivate: [RoleAccessGuard],
      },
      {
        path: 'employee',
        loadChildren: () =>
          import('../employee/employee.module').then((m) => m.EmployeeModule),
        canActivate: [RoleAccessGuard],
      },
      {
        path: 'community',
        loadChildren: () =>
          import(
            '../../common/modules/user-notice-board/user-notice-board.module'
          ).then((m) => m.UserNoticeBoardModule),
      },
      {
        path: 'community/:postId',
        loadChildren: () =>
          import(
            '../../common/modules/user-notice-board/user-notice-board.module'
          ).then((m) => m.UserNoticeBoardModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
